<template>
    <div class="page-bg login" v-if="!isLoading">
        <v-container fill-height justify-center>
            <div class="login-block" v-if="!instituteError">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <template v-if="dialog">
                    <div class="text-center">
                        <v-dialog
                            v-model="dialog"
                            width="530"
                            class="modal-size"
                            persistent="true"
                        >
                            <v-card>
                                <div class="Client-logo modal-logo">
                                    <img :src="logo" class="Client-logo-img" />
                                </div>
                                <v-card-text class="link-area">
                                    <div class="msg-text">
                                        We are happy to inform you that we have
                                        moved to a more stable platform.
                                    </div>
                                    <a
                                        class="msg-text3"
                                        href="https://mseducation.eduracle.com"
                                        >https://mseducation.eduracle.com</a
                                    >
                                    <div>
                                        You can now access this portal using
                                        above link with same login credentials
                                        that you had in the previous portal.
                                    </div>
                                </v-card-text>
                                <div class="msg-text2">
                                    <img
                                        src="@/assets/img/logo-footer.png"
                                        class="master-logo"
                                    />
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>
                <v-form v-else class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field
                                @keyup.enter="submit"
                                autocomplete="new-password"
                                v-model="userId"
                                label="Email ID"
                                dense
                                outlined
                                hide-details
                                ref="userId"
                            ></v-text-field>
                            <InputError :data="error.email" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero icon-input">
                            <v-text-field
                                @keyup.enter="submit"
                                autocomplete="new-password"
                                v-model="password"
                                label="Password"
                                dense
                                outlined
                                hide-details
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                            ></v-text-field>
                            <InputError :data="error.password" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="forgot-pass">
                                <span
                                    v-if="!onlineInstitute"
                                    class="forgot-pass-label"
                                    @click="onForgotPassword"
                                    >Forgot Password?</span
                                >
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary">
                                <div class="user-new-signup">
                                    <span v-if="!this.onlineInstitute" class="new-user">New user?</span>
                                    <span v-if="!this.onlineInstitute" @click="signUp" class="signup-user"
                                        >Sign Up!</span
                                    >
                                </div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="submit"
                                        class="right-btn cust-btn"
                                        color="primary"
                                        >Log In</v-btn
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img
                        src="@/assets/img/logo-footer.png"
                        class="master-logo"
                    />
                </div>
            </div>
            <div class="institute" v-else>
                {{ instituteError }}
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import menuList from "@/utils/menu";
import Vue from "vue";  
import VueCookies from 'vue-cookies';
import constants from "@/utils/constants.js";
Vue.use(VueCookies)

export default {
    name: "login",

    data: () => ({
        show1: false,
        userId: "",
        password: "",
        dialog: false,
        logo: null,
        menus: [],
        error: {
            email: {
                type: null,
                message: null,
            },
            password: {
                type: null,
                message: null,
            },
        },
        keepMeLoggedIn:false,
        isLoading: false,
        onlineInstitute: false,
        instituteError:''
    }),
    created() {
        this.loadInstituteDetails();
        if (
            `${window.location.protocol}//${window.location.host}` ===
            "https://mseducation.dev.eduracle.com"
        ) {
            this.dialog = true;
        }
        sessionStorage.removeItem('excludeRoute')
    },
    mounted() {
        this.onlineInstitute = (this.myInstitute && this.myInstitute.id == constants.ONLINE_INSTITUTE_ID) ? true : false;
        this.$refs.userId.focus();
            this.isLoading = true
        let token = JSON.parse(this.$cookies.get('userToken'));
        let isValidUser = JSON.parse(this.$cookies.get('redirectFromWebsite'));
        let loggedInUsers = JSON.parse(this.$cookies.get('isLoggedIn'));
        this.keepMeLoggedIn = JSON.parse(this.$cookies.get('keepMeLoggedIn'));
        if ((this.keepMeLoggedIn) && localStorage.getItem('auth_token')) {
            this.$router.push({name:"home"})
        }
        this.$cookies.remove('redirectFromWebsite',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        if (isValidUser && token) {
            this.loginWebsite(token)
        }else if(loggedInUsers && token){
            this.loginWebsite(token)
        }
        else{
            this.isLoading = false
        }
    },
    watch: {
        userId(val) {
            this.error.email.type = null;
        },
        password(val) {
            this.error.password.type = null;
        },
    },
    computed: {
        ...mapState("userStore", ["isDefaultInstitute","myInstitute"]),
    },
    methods: {
        ...mapMutations("userStore", ["updateIsDefaultInstitute"]),
        ...mapActions({
            logIn: "userStore/logIn",
            getInstituteDetails: "userStore/getInstituteDetails",
            setPendingTestList: "userStore/setPendingTestList",
        }),
        onForgotPassword() {
            this.$router.push({ name: "forgot-password" });
        },
        signUp() {
            this.$router.push({ name: "signup" });
        },
        loadInstituteDetails() {
            this.getInstituteDetails()
                .then((response) => {
                    // this.logo = response.logo_url > "" ? response.logo_url : this.logo;
                    this.logo = this.getInstituteLogo();
                    let isDefaultInstitute = this.checkIsDefaultInstitute();
                    this.updateIsDefaultInstitute(isDefaultInstitute);
                    this.setPageTitle(isDefaultInstitute);
                    if (this.CUSTOM_INSTITUTE_ID.includes(response.id)) {
                        this.$router.push({ name: "customized-tests-myt" });
                        
                    }
                })
                .catch((e) => {
                    e.data.errors.map(err=>{
                        this.instituteError = err.message
                    })
                    if (this.logo == null) {
                        this.logo = require("@/assets/img/Login_Page_logo.png");
                    }
                });
        },
        submit(event) {
            event.preventDefault();
            this.$root.showLoader = true;

            if (this.validate()) {
                this.logIn({
                    username: this.userId.trim(),
                    password: this.password,
                    external: true
                })
                    .then((response) => {
                        if(response){
                            sessionStorage.setItem(
                                "onPopUpFeedBackModal",
                                true
                            );
                        }
                        if (!response.telegram_id && !this.isZeroKelvinInstitute()) {
                            sessionStorage.setItem(
                                "showVerifyTelegramBox",
                                true
                            );
                        }
                        // window.hj('identify',response.id,response)
                        if (response.username) {
                            this.setPendingTestList(null);
                            let redirectPath = "home";
                            let redirectAfterLogin = sessionStorage.getItem(
                                "redirectAfterLogin"
                            );
                            let excludeRoute = ['practice-session-question-view','topic-health', 'chapters-health', 'test']
                            const user = JSON.parse(
                                sessionStorage.getItem("oldRoleId")
                            );

                            if (redirectAfterLogin && user === response.role_id && !excludeRoute.includes(redirectAfterLogin)){
                                redirectPath = redirectAfterLogin;
                            }
                            sessionStorage.removeItem("redirectAfterLogin");
                            this.$router.push({ name: redirectPath });
                        } else {
                            this.$router.push({ name: "change-password" });
                        }
                        this.$root.showLoader = false;
                        // this.$cookies.remove('userDetails');
                    })
                    .catch((e) => {
                        this.$root.showLoader = false;
                    });
            } else {
                this.$root.showLoader = false;
            }
        },
        validate() {
            let isValid = true;

            this.error.email.type = null;
            this.error.password.type = null;
            if (!this.userId || this.userId.trim().length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email/username";
                isValid = false;
            }
            // else if (!this.isValidEmail(this.userId.trim())) {
            //     this.error.email.type = "error";
            //     this.error.email.message =
            //     "Please enter a valid email ID";
            //     isValid = false;
            // }

            if (!this.password || this.password.trim().length < 1) {
                this.error.password.type = "error";
                this.error.password.message = "Please enter password";
                isValid = false;
            }
            return isValid;
        },
        loginWebsite(token){
            let reqData = {
                token:  token,
                external:true,
                keepMeLoggedIn:this.keepMeLoggedIn

            }
            this.$root.showLoader = true;
            this.isLoading = true
            this.logIn(reqData)
            .then(response=>{
                if(response){
                    sessionStorage.setItem(
                        "onPopUpFeedBackModal",
                        true
                    );
                }
                if (!response.telegram_id && !this.isZeroKelvinInstitute()) {
                    sessionStorage.setItem(
                        "showVerifyTelegramBox",
                        true
                    )
                }
                let product = this.$cookies.get('upgrade');

                if (response.institute ===this.ONLINE_INSTITUTE_ID ) {
                    
                    if (product) {
                        this.$router.push({name:"my-subscription",query:{productId:product}})     
                    }else{
                        this.$router.push({name:"home"})
                    }
                }
                this.$root.showLoader = false;
                this.isLoading = false
            })
            .catch(err=>{
                this.$root.showLoader = false;
                this.isLoading = false

            })
        }
    },
};
</script>
